import React from "react";
import { Link } from "react-router";
import PropTypes from 'prop-types';

import style from "./Button.css";

const Button = ({ label, onClick, styles = {}, to = "#" }) => {
  let handleClick = () => {};

  if (onClick) {
    handleClick = (evt) => {
      evt.preventDefault();
      onClick(evt);
      return false;
    };
  }

  return (
    <Link
      to={to}
      onClick={handleClick}
      style={styles}
      className={style.button}>
      {label}
    </Link>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string,
  styles: PropTypes.object,
  onClick: PropTypes.func
};

export default Button;



// WEBPACK FOOTER //
// ./component/Button/index.js